import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../services/api";
import {  ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dialog } from "primereact/dialog";
import { set } from "react-hook-form";
const CopyUpdateList = () => {
    const toast = useRef(null);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [projects, setProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    /** Dialog and Details State */
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState([]);


    /** search Filtter function Start */
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            user_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            role_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            playbook_type: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

        });
        setGlobalFilterValue('');
    };
    /** search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue} onChange={onGlobalFilterChange}
                    // onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );


    useEffect(() => {
        getProjectDetails();
        initFilters();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);
    const getProjectDetails = () => {

        fetch(Api.API_BASE_URL + '/playbook-history/get', {
            method: "GET",


        })
            .then((response) => response.json())
            .then((response) => {

                setProjects(response.result);
                setIsLoading(false);


            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    }

    const onRowSelect = (event) => {
        const { data } = event;
        setSelectedProduct(data);

        var _body = {
            user_id: data.user_id,
        };

        fetch(Api.API_BASE_URL + '/playbook-history/get-by-user', {
            method: "POST",
            body: JSON.stringify(_body),
        })
            .then(response => response.json())
            .then(details => {
                setSelectedDetails(details.result);
                setDialogVisible(true);
            })
            .catch(error => {
                console.error("Error fetching details:", error);
            });
    };

    // const dialogFooter = (
    //     <div className="p-d-flex p-jc-end">
    //         <button className="p-button p-component p-button-text" onClick={() => setDialogVisible(false)}>
    //             Close
    //         </button>
    //     </div>
    // );

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />

            <Dialog
                visible={dialogVisible}
                style={{ width: '65vw' }}
                header="Details"
                maximizable
                dismissableMask="true"
                onHide={() => { setDialogVisible(false); setSelectedDetails(null); setSelectedProduct(null) }} 

            // footer={dialogFooter}
            >

                {/* {selectedDetails.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))} */}
                <DataTable
                    value={selectedDetails}
                    paginator
                    rows={10}
                    dataKey="id"
                // header="Details Table"
                >
                    <Column field="created_at" header="Created At" style={{ textAlign: 'center' }} ></Column>
                    <Column field="user_name" header="Created By" style={{ textAlign: 'center' }}></Column>
                    <Column field="role_name" header="Role" style={{ textAlign: 'center' }}></Column>
                    <Column field="project_name" header="Project Name" style={{ textAlign: 'center' }}  ></Column>
                    <Column field="playbook_type" header="Playbook Name" style={{ textAlign: 'center' }}></Column>
                    <Column field="type" header="Client Update" body={(e) => e.type === 'Sent' ? '✅' : ''} style={{ textAlign: 'center' }}></Column>
                    {/* Add more columns as needed */}
                </DataTable>
            </Dialog>

            <div className="pagination-datable-height">
                {isLoading ? (
                    <div className="loading-spinner">
                        Loading...
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                        <TabPanel header="" className="p-2 pb-2" >
                            <div className=" m-0" style={{ width: "100%" }} >
                                <DataTable
                                    value={projects}
                                    paginator
                                    rows={12}
                                    dataKey="id"
                                    selectionMode="single"
                                    selection={selectedProduct}
                                    onSelectionChange={(e) => setSelectedProduct(e.value)}
                                    onRowSelect={onRowSelect}
                                    header={header}
                                    filters={filters}
                                    globalFilterFields={['project_name', 'role_name', 'user_name', 'type']}
                                >

                                    <Column field="user_name" header="Created By" style={{ textAlign: 'center' }}></Column>
                                    <Column field="role_name" header="Role" style={{ textAlign: 'center' }}></Column>
                                  
                                </DataTable>
                            </div>
                        </TabPanel>



                    </TabView>
                )}
            </div>



        </>
    )
}

export default CopyUpdateList;